/** @param {string | undefined | null} lang */
export function isViLocale(lang) {
  return Boolean(lang?.startsWith('vi'));
}

/**
 * @param {string} en
 * @param {string | null | undefined} vi
 * @param {string | undefined | null} lang
 */
export function pickLocalizedText(en, vi, lang) {
  if (isViLocale(lang) && vi?.trim()) return vi.trim();
  return en ?? '';
}

/**
 * @param {import('./articlesApi').ArticleRow} row
 * @param {string | undefined | null} lang
 */
export function localizeArticleRow(row, lang) {
  if (!row) return row;
  if (!isViLocale(lang)) return row;
  return {
    ...row,
    title: pickLocalizedText(row.title, row.title_vn, lang),
    excerpt: pickLocalizedText(row.excerpt, row.excerpt_vn, lang),
    content: pickLocalizedText(row.content, row.content_html_vn, lang),
  };
}

/**
 * @param {{ slug: string, label: string, label_vn?: string | null }} row
 * @param {string | undefined | null} lang
 */
export function localizePaLabel(row, lang) {
  if (!row) return '';
  return pickLocalizedText(row.label, row.label_vn, lang) || row.slug;
}

/**
 * @param {Record<string, string>} paMap slug -> EN label
 * @param {Array<{ slug: string, label: string, label_vn?: string | null }>} labels
 * @param {string | undefined | null} lang
 */
export function buildLocalizedPaMap(paMap, labels, lang) {
  if (!isViLocale(lang) || !labels?.length) return paMap ?? {};
  const o = { ...(paMap ?? {}) };
  for (const row of labels) {
    if (row.slug && row.label_vn) o[row.slug] = row.label_vn;
  }
  return o;
}

/**
 * @param {object} member team_members row shape
 * @param {string | undefined | null} lang
 */
export function localizeTeamMemberRow(member, lang) {
  if (!member || !isViLocale(lang)) return member;
  const bio_vn = Array.isArray(member.bio_paragraphs_vn) ? member.bio_paragraphs_vn : [];
  const expertise_vn = Array.isArray(member.expertise_vn) ? member.expertise_vn : [];
  return {
    ...member,
    role: pickLocalizedText(member.role, member.role_vn, lang),
    bio_paragraphs: bio_vn.length ? bio_vn : member.bio_paragraphs,
    expertise: expertise_vn.length ? expertise_vn : member.expertise,
    profile_html: pickLocalizedText(member.profile_html ?? '', member.profile_html_vn, lang) || null,
  };
}
